import CITIES_1 from './cityData';
import CITIES_2 from './cityData2';
import CITIES_3 from './cityData3';

const CITIES = { ...CITIES_1, ...CITIES_2, ...CITIES_3 };

export default CITIES;
export { CITIES };
